import { useQuery } from 'react-query';

import { getVersionDetails as queryFn } from 'api/endPoints/getVersionDetails';
import { QueryKeys } from 'api/queryKeys';

import { ProjectTreeNode } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';

export const useQueryVersionList = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['versionsListByContract', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(Number.isInteger(params.contractId)) && Boolean(params.ids.length > 0),
        cacheTime: 0,
    });
};

export interface QueryParams {
    contractId: number | undefined;
    ids: number[];
}

export interface QueryResponse {
    contractId: number;
    contractName: string;
    contractUuid: ProjectTreeNode['uuid'];
    maxLevel: number;
    projectId: number;
    projectName: string;
    projectUuid: ProjectTreeNode['uuid'];
    sourceFile: string;
    versionDate: number;
    versionDbId: number;
    versionHashCode: number;
    versionName: string;
    versionUniqueId: number;
}
